import { keyframes } from 'styled-components';
import styled from 'styled-components';

export const meltAnimation = keyframes`
  0% {
    transform: translateY(0) skew(0deg);
    filter: none;
    opacity: 1;
  }
  15% {
    transform: translateY(10vh) skew(-20deg) scaleX(1.2);
    filter: blur(1px) hue-rotate(45deg);
  }
  35% {
    transform: translateY(30vh) skew(15deg) scaleX(0.8);
    filter: blur(2px) hue-rotate(90deg) contrast(150%);
  }
  65% {
    transform: translateY(60vh) skew(-25deg) scaleX(1.4);
    filter: blur(3px) hue-rotate(180deg) brightness(1.2);
  }
  85% {
    transform: translateY(80vh) skew(30deg) scaleX(0.6);
    filter: blur(4px) hue-rotate(270deg) contrast(200%);
  }
  100% {
    transform: translateY(120vh) skew(-35deg) scaleX(0.3);
    filter: blur(5px) hue-rotate(360deg);
    opacity: 0;
  }
`;

export const glitchAnimation = keyframes`
  0% {
    transform: translate(0);
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
  }
  10% {
    transform: translate(-10px, 5px);
    clip-path: polygon(5% 0, 95% 0, 95% 100%, 5% 100%);
    filter: hue-rotate(90deg);
  }
  20% {
    transform: translate(15px, -8px) skewX(15deg);
    clip-path: polygon(0 10%, 100% 5%, 100% 95%, 0 90%);
    filter: invert(1);
  }
  30% {
    transform: translate(-8px, 12px) skewX(-10deg);
    clip-path: polygon(0 15%, 100% 20%, 100% 85%, 0 80%);
    filter: saturate(200%);
  }
  40% {
    transform: translate(12px, -10px) skewY(5deg);
    clip-path: polygon(5% 5%, 95% 0, 95% 95%, 5% 100%);
    filter: contrast(150%);
  }
  50% {
    transform: translate(-15px, 8px) skewY(-8deg);
    clip-path: polygon(10% 0, 90% 10%, 90% 90%, 10% 100%);
    filter: hue-rotate(180deg);
  }
  60% {
    transform: translate(10px, 15px);
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
    filter: invert(0.5);
  }
  70% {
    transform: translate(-12px, -8px) skewX(-15deg);
    clip-path: polygon(15% 15%, 85% 10%, 85% 85%, 15% 90%);
    filter: brightness(1.5);
  }
  80% {
    transform: translate(8px, 12px) skewX(10deg);
    clip-path: polygon(10% 10%, 90% 15%, 90% 90%, 10% 85%);
    filter: contrast(200%);
  }
  90% {
    transform: translate(-10px, -15px) skewY(-5deg);
    clip-path: polygon(5% 5%, 95% 10%, 95% 95%, 5% 90%);
    filter: saturate(150%);
  }
  100% {
    transform: translate(0);
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
    filter: none;
  }
`;

export const shakeAnimation = keyframes`
  0% { transform: translate(0, 0) rotate(0); }
  10% { transform: translate(-15px, 10px) rotate(-3deg); }
  20% { transform: translate(13px, -8px) rotate(2deg); }
  30% { transform: translate(-10px, 15px) rotate(-4deg); }
  40% { transform: translate(8px, -12px) rotate(1deg); }
  50% { transform: translate(-13px, 8px) rotate(-2deg); }
  60% { transform: translate(15px, -15px) rotate(3deg); }
  70% { transform: translate(-8px, 12px) rotate(-1deg); }
  80% { transform: translate(10px, -10px) rotate(4deg); }
  90% { transform: translate(-12px, 15px) rotate(-3deg); }
  100% { transform: translate(0, 0) rotate(0); }
`;

export const distortAnimation = keyframes`
  0% {
    clip-path: inset(0 0 0 0);
    transform: scale(1);
  }
  20% {
    clip-path: inset(20% -20px 30% 0);
    transform: scale(1.1) skewX(10deg);
  }
  40% {
    clip-path: inset(40% 30% 20% -30px);
    transform: scale(0.9) skewX(-15deg);
  }
  60% {
    clip-path: inset(10% -40px 50% 20%);
    transform: scale(1.2) skewY(5deg);
  }
  80% {
    clip-path: inset(30% 20% 30% -20px);
    transform: scale(0.8) skewY(-8deg);
  }
  100% {
    clip-path: inset(0 0 0 0);
    transform: scale(1);
  }
`;

// Add new effect for windows
export const windowCrashAnimation = keyframes`
  0% {
    transform: translate(0, 0) rotate(0) scale(1);
    filter: none;
  }
  20% {
    transform: translate(30px, -20px) rotate(5deg) scale(0.95);
    filter: brightness(1.2) contrast(1.3);
  }
  40% {
    transform: translate(-25px, 25px) rotate(-8deg) scale(1.1);
    filter: hue-rotate(90deg) saturate(150%);
  }
  60% {
    transform: translate(20px, 30px) rotate(12deg) scale(0.9);
    filter: invert(0.3) brightness(0.8);
  }
  80% {
    transform: translate(-30px, -15px) rotate(-15deg) scale(1.2);
    filter: contrast(200%) hue-rotate(180deg);
  }
  100% {
    transform: translate(0, 100vh) rotate(20deg) scale(0.5);
    filter: blur(10px) brightness(0.5);
  }
`;

// Screen tear effect that looks like claw marks
export const screenTearAnimation = keyframes`
  0% {
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
  }
  15% {
    clip-path: polygon(
      0 0, 100% 0, 100% 100%, 0 100%,
      20% 0, 23% 100%,
      45% 0, 48% 100%,
      70% 0, 73% 100%,
      95% 0, 98% 100%
    );
  }
  30%, 100% {
    clip-path: polygon(
      0 0, 100% 0, 100% 100%, 0 100%,
      20% 0, 18% 100%,
      45% 0, 43% 100%,
      70% 0, 68% 100%,
      95% 0, 93% 100%
    );
  }
`;

// Chaotic bounce animation for windows
export const bounceAnimation = keyframes`
  0% {
    transform: translate(0, 0) rotate(0deg);
  }
  20% {
    transform: translate(30px, 40vh) rotate(5deg);
  }
  40% {
    transform: translate(-50px, 60vh) rotate(-8deg);
  }
  60% {
    transform: translate(20px, 80vh) rotate(12deg);
  }
  80% {
    transform: translate(-40px, 90vh) rotate(-15deg) scale(0.9);
  }
  90% {
    transform: translate(30px, 95vh) rotate(10deg) scale(0.8);
  }
  95% {
    transform: translate(0, 92vh) rotate(-5deg) scale(0.85);
  }
  100% {
    transform: translate(${Math.random() * 100 - 50}px, 90vh) rotate(${Math.random() * 20 - 10}deg) scale(0.8);
  }
`;

// Static interference effect
export const staticEffect = keyframes`
  0% {
    background-position: 0 0;
    filter: brightness(1) contrast(1);
  }
  20% {
    background-position: -10px 0;
    filter: brightness(1.2) contrast(1.3);
  }
  40% {
    background-position: 10px -5px;
    filter: brightness(0.8) contrast(1.5);
  }
  60% {
    background-position: -5px 5px;
    filter: brightness(1.1) contrast(0.9);
  }
  80% {
    background-position: 5px -10px;
    filter: brightness(0.9) contrast(1.2);
  }
  100% {
    background-position: 0 0;
    filter: brightness(1) contrast(1);
  }
`;

// Taskbar malfunction animation
export const taskbarMalfunctionAnimation = keyframes`
  0% {
    transform: translateY(0);
    clip-path: inset(0 0 0 0);
  }
  25% {
    transform: translateY(10px);
    clip-path: inset(0 5% 0 10%);
  }
  50% {
    transform: translateY(-5px);
    clip-path: inset(0 15% 0 5%);
  }
  75% {
    transform: translateY(8px);
    clip-path: inset(0 10% 0 15%);
  }
  100% {
    transform: translateY(0);
    clip-path: inset(0 0 0 0);
  }
`;

// Background grid malfunction
export const gridMalfunctionAnimation = keyframes`
  0% {
    background-size: 75px 75px;
    background-position: center center;
  }
  25% {
    background-size: 80px 70px;
    background-position: left center;
  }
  50% {
    background-size: 70px 80px;
    background-position: right center;
  }
  75% {
    background-size: 85px 65px;
    background-position: center bottom;
  }
  100% {
    background-size: 75px 75px;
    background-position: center center;
  }
`;

// CMD window glitch
export const cmdGlitchAnimation = keyframes`
  0% { transform: translate(0) skew(0deg); }
  20% { transform: translate(-10px, 5px) skew(2deg); }
  40% { transform: translate(8px, -4px) skew(-3deg); }
  60% { transform: translate(-6px, 3px) skew(1deg); }
  80% { transform: translate(4px, -2px) skew(-2deg); }
  100% { transform: translate(0) skew(0deg); }
`;

// Randomized bounce paths for desktop icons
export const createRandomBounceAnimation = (index) => keyframes`
  0% {
    transform: translate(0, 0) rotate(0deg);
  }
  25% {
    transform: translate(
      ${Math.random() * 300 - 150}px, 
      ${Math.random() * 200}px
    ) rotate(${Math.random() * 180 - 90}deg);
  }
  50% {
    transform: translate(
      ${Math.random() * 400 - 200}px, 
      ${Math.random() * 300 + 100}px
    ) rotate(${Math.random() * 360 - 180}deg);
  }
  75% {
    transform: translate(
      ${Math.random() * 500 - 250}px, 
      ${Math.random() * 400 + 200}px
    ) rotate(${Math.random() * 540 - 270}deg);
  }
  100% {
    transform: translate(
      ${Math.random() * 600 - 300}px,
      100vh
    ) rotate(${Math.random() * 720 - 360}deg);
  }
`;

// Enhanced CMD window glitch
export const cmdChaosAnimation = keyframes`
  0% {
    transform: translate(0, 0) rotate(0deg) scale(1);
    filter: none;
  }
  15% {
    transform: translate(-20px, 15px) rotate(-5deg) scale(0.95);
    filter: hue-rotate(90deg) brightness(1.2);
  }
  35% {
    transform: translate(25px, -20px) rotate(8deg) scale(1.1);
    filter: contrast(1.5) brightness(0.8);
  }
  55% {
    transform: translate(-15px, 25px) rotate(-12deg) scale(0.9);
    filter: invert(0.2) hue-rotate(180deg);
  }
  75% {
    transform: translate(30px, -15px) rotate(15deg) scale(1.05);
    filter: saturate(2) brightness(1.3);
  }
  100% {
    transform: translate(0, 0) rotate(0deg) scale(1);
    filter: none;
  }
`;

// Create unique bounce paths for each icon
export const createIconBounceAnimation = (index) => keyframes`
  0% {
    transform: translate(0, 0) rotate(0deg);
  }
  5% { // Quick initial spread
    transform: translate(
      ${(index % 3) * 200 - 200}px,
      ${Math.floor(index / 3) * 100}px
    ) rotate(${Math.random() * 30 - 15}deg);
  }
  20%, 40%, 60%, 80% { // Multiple chaotic bounces with no smooth interpolation
    transform: translate(
      ${Math.min(Math.max(Math.random() * window.innerWidth - 100, 0), window.innerWidth - 100)}px,
      ${Math.min(Math.random() * (window.innerHeight - 140), window.innerHeight - 140)}px
    ) rotate(${Math.random() * 360 - 180}deg);
  }
  30%, 50%, 70%, 90% { // Intermediate positions
    transform: translate(
      ${Math.min(Math.max(Math.random() * window.innerWidth - 100, 0), window.innerWidth - 100)}px,
      ${Math.min(Math.random() * (window.innerHeight - 140), window.innerHeight - 140)}px
    ) rotate(${Math.random() * -360 + 180}deg);
  }
  100% {
    transform: translate(
      ${Math.min(Math.max(Math.random() * window.innerWidth - 100, 0), window.innerWidth - 100)}px,
      ${Math.min(Math.random() * (window.innerHeight - 140), window.innerHeight - 140)}px
    ) rotate(${Math.random() * 720 - 360}deg);
  }
`;

// Enhanced taskbar chaos with ramp-up
export const taskbarChaosAnimation = keyframes`
  0% {
    transform: translateY(0);
  }
  25% {
    transform: translateY(-5px) rotate(0.5deg);
  }
  50% {
    transform: translateY(3px) rotate(-0.5deg);
  }
  75% {
    transform: translateY(-2px) rotate(0.25deg);
  }
  100% {
    transform: translateY(35px);
  }
`; 